import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { Modal } from "antd";
import axiosLLInstance from "../../utils/axiosLLInstance";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { notifyUser } from "../../utils/notifyUser";

const validate = (values) => {
  const errors = {};
  if (!values.name?.trim()) {
    errors.name = "Required";
  }
  values.name = values.name.trim().replace(/\s+/g, "_");
  if (!values.category) {
    errors.category = "Required";
  }
  return errors;
};

export default function AddAdminFleet({ addNewFleet }) {
  const [open, setOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const admin = useSelector((state) => state.users.admin);
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      if (!categories.length) getCategories();
    }
  }, [open]);

  const getCategories = async () => {
    try {
      const { data } = await axiosLLInstance.get("/categories");
      setCategories(data);
      setLoaded(true);
    } catch (error) {
      console.error("Error fetching categories ", error);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      category: categories?.[0] || "",
      description: "",
    },
    enableReinitialize: true,
    validate,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const handleFormSubmit = (values) => {
    const { name, category, description } = values;
    const { id: category_id, name: category_name } =
      typeof category === "string" ? JSON.parse(category) : categories[0];
    const { id: admin_id, name: admin_name } = admin;
    axiosLLInstance
      .post(`/fleets`, {
        name,
        category_name,
        category_id,
        admin_name,
        admin_id,
        description,
      })
      .then(({ data }) => {
        addNewFleet(data);
        setOpen(false);
        notifyUser({
          message: "Fleet Added",
          type: "success",
        });
      })
      .catch((err) => {
        console.error("Error adding fleet ", err);
      });
  };

  return (
    <>
      <div className="adminBtn">
        <button
          onClick={() => {
            formik.resetForm();
            setOpen(true);
          }}
          className="btn btn-neutral font-bold py-2 px-4 rounded-[10px] flex items-center justify-between text-[14px]"
        >
          Add Fleet <FaPlus className="pl-1 text-[18px]" />
        </button>
      </div>
      {open && (
        <Modal
          centered
          width={700}
          open={open}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
          footer={[]}
        >
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-2">
              <div className="form-control">
                <label className="label">
                  <span className="text-[#B6B8BB] dark:white text-[17px] font-[500] landing-[19px]">
                    Name
                  </span>
                </label>
                <div className="flex items-center h-12 px-4 bg-white border border-gray-200 rounded-xl shadow-sm">
                  <input
                    type="text"
                    className="w-full bg-transparent outline-none border-none text-gray-900 placeholder:text-gray-400"
                    name="name"
                    placeholder="Enter_fleet_name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                  />
                </div>
                <span className="h-[2px] mt-2 text-rose-600 text-[12px]">
                  {formik.errors.name && formik.touched.name && (
                    <div>{formik.errors.name}</div>
                  )}
                </span>
              </div>

              <div className="form-control">
                <label className="label">
                  <span className="text-[#B6B8BB] text-[17px] font-[500] landing-[19px]">
                    Description (Optional)
                  </span>
                </label>
                <div className="px-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm">
                  <textarea
                    className="w-full min-h-[90px] resize-none bg-transparent outline-none border-none text-gray-900 placeholder:text-gray-400"
                    name="description"
                    placeholder="Enter Description"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.description}
                  />
                </div>
                <span className="h-[2px] mt-2"></span>
              </div>

              <div className="form-control">
                <label className="label">
                  <span className="text-[#B6B8BB] dark:white text-[17px] font-[500] landing-[19px]">
                    Select Category
                  </span>
                </label>
                <div>
                  <select
                    className="w-full h-12 px-4 bg-white border border-gray-200 rounded-xl shadow-sm outline-none text-gray-900"
                    id="category"
                    name="category"
                    onChange={formik.handleChange}
                    value={formik.values.category}
                    onBlur={formik.handleBlur}
                  >
                    {categories.map((category) => {
                      return (
                        <option
                          value={JSON.stringify(category)}
                          key={category.id}
                        >
                          {category.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <span className="h-[2px] mt-2 text-rose-600 text-[12px]">
                  {formik.errors.category && formik.touched.category && (
                    <div>{formik.errors.admin}</div>
                  )}
                </span>
                {loaded && categories.length === 0 && (
                  <p
                    className="text-red-500 cursor-pointer"
                    onClick={() => navigate("/categories")}
                  >
                    Category list is empty, please Add new Category.
                  </p>
                )}
              </div>
            </div>
            <div className="mt-8">
              <button
                type="submit"
                className="btn text-white gap-2 btn-neutral btn-block rounded text-[17px] font-[500] landing-[19px]"
              >
                Submit
              </button>
            </div>
          </form>
        </Modal>
      )}
    </>
  );
}
